import { typeDocument } from "../api/typeDocument";
export const getTypeDocumentsActives = (countryId) => {
  return typeDocument.getActives(countryId).then((response) => response);
};
